// Environment Variables with Defaults
const getEnv = (key, defaultValue) => {
  // Try import.meta.env first (modern), then process.env (for compatibility)
  return typeof import.meta !== 'undefined' && import.meta.env?.[key]
    ? import.meta.env[key]
    : typeof process !== 'undefined' && process.env?.[key]
      ? process.env[key]
      : defaultValue;
};

const DOMAIN_NAME = getEnv('VITE_DOMAIN', 'ph.al');
const PROTOCOL = getEnv('VITE_PROTOCOL', 'https');
const DB_SUBDOMAIN = getEnv('VITE_DB_SUBDOMAIN', `mysql.${DOMAIN_NAME}`);
const DB_PRIMARY_HOST = getEnv('VITE_DB_PRIMARY_HOST', 'srv1918.hstgr.io');
const AWS_API_GATEWAY = getEnv(
  'VITE_AWS_API_GATEWAY_URL',
  'https://r3jx78in5l.execute-api.us-east-2.amazonaws.com/prod/gjclambdaenvoke',
);
const AWS_REGION = getEnv('VITE_AWS_COGNITO_REGION', 'us-east-2');

// AWS Cognito Configuration
export const COGNITO = {
  USER_POOL_ID: 'us-east-2_hvEbl5r3G',
  CLIENT_ID: '2pibut80k32ggffm4gjr2aplao',
  REGION: 'us-east-2',
};

// Storage Keys
export const STORAGE = {
  JWT_TOKEN: 'gjcjwtidtokenkey',
  USER_DATA: 'gjcUserData',
};

// Token Settings
export const TOKEN = {
  EXPIRATION_TIME_MS: 3600000, // 1 hour in milliseconds
};

// Domain Configuration (from environment variables)
export const DOMAIN = {
  BASE_URL: `${PROTOCOL}://${DOMAIN_NAME}`,
  SUBDOMAIN_MYSQL: DB_SUBDOMAIN,
  PROTOCOL,
  NAME: DOMAIN_NAME,
};

// API Configuration
export const API = {
  ALLOWED_ORIGIN: DOMAIN.BASE_URL,
  ALLOWED_METHODS: 'GET, POST, OPTIONS',
  ALLOWED_HEADERS: 'Content-Type',
  BASE_ENDPOINT_PATH: 'libfolder/gjc_api.php',
  ENDPOINTS: {
    MAIN_API: 'libfolder/gjc_api.php',
    RROGAT_SEARCH: 'libfolder/gjc_search_rrogat_by_id.php',
    PLATE_SEARCH: 'libfolder/gjc_search_targat_by_id.php',
    CELL_SEARCH: 'libfolder/gjc_search_tel_by_id.php',
    NAME_BOTTOM_100: 'libfolder/gjc_name_bottom_100.php',
    PLATE_BY_PLATE_ID: 'libfolder/gjc_search_by_targa.php',
    NAME_COUNT: 'libfolder/gjc_name_count_and_pos.php',
    SURNAME_COUNT: 'libfolder/gjc_surname_count_and_pos.php',
    NAME_TOP_100: 'libfolder/gjc_name_top_100.php',
    SURNAME_TOP_100: 'libfolder/gjc_surname_top_100.php',
    CELL_BY_NUMBER: 'libfolder/gjc_search_by_tel.php',
  },
};

// AWS Configuration (from environment variables)
export const AWS = {
  COGNITO_REGION: AWS_REGION,
  API_GATEWAY_URL: AWS_API_GATEWAY,
};

// Database Configuration (from environment variables)
export const DATABASE = {
  PRIMARY_HOSTNAME: DB_PRIMARY_HOST,
  HOSTNAMES: ['localhost', DB_SUBDOMAIN, 'mysql.hostinger.com'],
  // First Database
  DB1: {
    USERNAME: 'u685817080_phpuseradmingj',
    PASSWORD: 'Ko3J9ocDh37c!',
    NAME: 'u685817080_gjc_new_databa',
  },
  // Second Database (Rrogat)
  DB2: {
    USERNAME: 'u685817080_phpuseradmin',
    PASSWORD: 'gjsn3GCb9Prf3xX!',
    NAME: 'u685817080_rrogat2021',
  },
  CHARSET: 'utf8',
};
